import React, { createContext } from 'react'
import { ResolveImageUrlArgs } from 'src/components/image/image'
import { ThemeInterface } from './ThemeInterface'
import { defaultTheme } from './default-theme'

export interface LibraryConfig {
    theme?: ThemeInterface
    /**
     * Use this for the cloudflare image resizer - it should be the base URL before the
     * parameters specific to each image that come after it.
     */
    imageResizerBaseUrl?: string
    /**
     * This allows the consumer to pass in a completely custom function to return the URL
     * of the image for each of our standard image sizes, in case it needs to use something
     * other than Cloudflare Images (e.g. Sanity CMS, or a mock image service)
     */
    imageUrlResolver?: (args: ResolveImageUrlArgs) => string
}

// tell typescript that theme is always defined
type RequiredLibraryConfig = LibraryConfig & { theme: ThemeInterface }

export const LibraryConfigContext = createContext<RequiredLibraryConfig>(
    {} as RequiredLibraryConfig
)

export function LibraryConfigProvider({
    config,
    children,
}: {
    config: LibraryConfig
    children: NonNullable<React.ReactNode>
}) {
    // TODO - default imageResizerBaseUrl should be the default base URL we're using
    // with cloudflare images
    const mergedConfig = {
        ...config,
        theme: {
            mainColors: {
                ...defaultTheme.mainColors,
                ...config?.theme?.mainColors,
            },
        },
    }

    return (
        <LibraryConfigContext.Provider value={mergedConfig}>
            {children}
        </LibraryConfigContext.Provider>
    )
}
